import request from '@/utils/httpClient'

// supplier/page
// 批量删除
export function deleteCompanyById(id: number) {
  return request({
    url: `supplier/${id}`,
    method: 'delete'
  })
}

// 获取详情
export function getCompanyDetailById(id: number) {
  return request({
    url: `supplier/${id}`,
    method: 'get'
  })
}

// 获取列表
export function getCompanyList(params?: object) {
  return request({
    url: 'supplier/page',
    method: 'get',
    params
  })
}

// 获取下拉数据
export function getDropdown(params?: object) {
  return request({
    url: 'supplier/dropdown',
    method: 'get',
    params
  })
}

// 获取审批列表
export function getReviewCompanyList(params?: object) {
  return request({
    url: 'supplier/review/page',
    method: 'get',
    params
  })
}

// 获取修改审批信息
export function reviewsupplierById(id: number) {
  return request({
    url: `supplier/review/${id}`,
    method: 'get'
  })
}

// 通过审批
export function reviewApprove(id: number, data?: object) {
  return request({
    url: `supplier/${id}/actions/review/approve`,
    method: 'put',
    data
  })
}

// 通过拒绝 TODO: add reject msg
export function reviewReject(id: number, data?: object) {
  return request({
    url: `supplier/${id}/actions/review/reject`,
    method: 'put',
    data
  })
}
